var $d1a348ee160b1c35$exports = {};
$d1a348ee160b1c35$exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "placeholder": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}\u{2026}`
};


export {$d1a348ee160b1c35$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
